import ivclass from '@invideoio/web-shared/Modules/IVClass';

interface TitleProp {
  firstLine: string;
  secondLine?: string;
}

const CardTitle = ({ firstLine, secondLine }: TitleProp) => {
  return (
    <h3
      className={ivclass(
        'iv-text-grey-100',
        'xl:iv-text-heading-s iv-text-heading-3xs sm:iv-text-heading-6xs',
        'xl:iv-m-heading-s iv-m-heading-3xs sm:iv-m-heading-6xs',
        'iv-font-extrabold',
      )}
    >
      <span className={ivclass('xl:iv-block lg:iv-block')}>{firstLine}</span>
      {secondLine}
    </h3>
  );
};

export default CardTitle;
